import { CardShift, CardValue, Direction } from "../../interface/game";
import { GameDescription, PileDescription } from "../game-description";
import { pileContiguousDragPolicy } from "../pile-annotation/drag-contiguous";
import { pileTopOnlyDragPolicy } from "../pile-annotation/drag-top-only";
import { pileNoDragPolicy } from "../pile-annotation/no-drag";
import { pileOpenCardsPolicy } from "../pile-annotation/open-cards";
import { pileRevealTopPolicy } from "../pile-annotation/reveal-top";
import { pileConditionalClickPolicy } from "../pile-click/conditional-click-policy";
import { pileClickReturnAllFromPile } from "../pile-click/return-all-from-pile";
import { pileClickRevealToPile } from "../pile-click/reveal-to-pile";
import { PileDropCardValuePolicy } from "../pile-drop/drop-card-value";
import { PileConditionalDropPolicy } from "../pile-drop/drop-conditional";
import { PileContiguousPolicy } from "../pile-drop/drop-contiguous";
import { PileNoDropPolicy } from "../pile-drop/no-drop";
import { sequenceRedBlackPolicy } from "../pile-sequence/sequence-red-black-policy";
import { sequenceSingleSuitPolicy } from "../pile-sequence/sequence-single-suit-policy";
import { allFaceDownSetup } from "../pile-setup/all-face-down";
import { allFaceUpSetup } from "../pile-setup/all-face-up";
import { topFaceUpSetup } from "../pile-setup/top-face-up";
import { winAllCardsOnPiles } from "../win-condition/all-cards-on-piles";

export const Klondike: GameDescription = {
    rows: 10,
    cols: 9,
    win: winAllCardsOnPiles([1,2,3,4].map((index) => `foundation-${index}`)),
    piles: [
        ...[1,2,3,4,5,6,7].map((index): PileDescription => ({
            pileId: `tableau-${index}`,
            row: 2,
            col: 2+index,
            direction: Direction.south,
            setup: topFaceUpSetup(index),
            annotationPolicies: [
                pileOpenCardsPolicy(),
                pileRevealTopPolicy(),
                pileContiguousDragPolicy(sequenceRedBlackPolicy())
            ],
            dropPolicy: new PileConditionalDropPolicy(
                new PileContiguousPolicy(sequenceRedBlackPolicy()),
                { 0: new PileDropCardValuePolicy(CardValue.king) }
            )
        })),
        ...[1,2,3,4].map((index): PileDescription => ({
            pileId: `foundation-${index}`,
            row: 1,
            col: 4+index,
            direction: Direction.south,
            setup: allFaceUpSetup(0),
            annotationPolicies: [
                pileOpenCardsPolicy(CardShift.SHUT),
                pileTopOnlyDragPolicy()
            ],
            dropPolicy: new PileConditionalDropPolicy(
                new PileContiguousPolicy(sequenceSingleSuitPolicy(false)),
                { 0: new PileDropCardValuePolicy(CardValue.ace) }
            )
        })),
        {
            pileId: 'waste',
            row: 1,
            col: 2,
            direction: Direction.east,
            setup: allFaceUpSetup(0),
            annotationPolicies: [
                pileTopOnlyDragPolicy()
            ],
            dropPolicy: new PileNoDropPolicy()
        },
        {
            pileId: 'stock',
            row: 1,
            col: 1,
            direction: Direction.south,
            setup: allFaceDownSetup(-1),
            annotationPolicies: [
                pileNoDragPolicy()
            ],
            dropPolicy: new PileNoDropPolicy(),
            clickPolicy: pileConditionalClickPolicy(
                pileClickRevealToPile('waste', 3),
                { 0: pileClickReturnAllFromPile('waste') }
            )
        }
    ]
}